var map = {
	"./Italic.svg": "4a3d",
	"./abc.svg": "5aea",
	"./address-align-bottom.svg": "4374",
	"./address-align-center.svg": "8b9a",
	"./address-align-left.svg": "119c",
	"./address-align-middle.svg": "6f4c",
	"./address-align-right.svg": "6521",
	"./address-align-top.svg": "51c4",
	"./address.svg": "e8fc",
	"./adjustments.svg": "af3e",
	"./align-left-image.svg": "2ff8",
	"./alignbottom.svg": "def1",
	"./aligncenter.svg": "faec",
	"./alignleft.svg": "1432",
	"./alignmiddle.svg": "42d1",
	"./alignright.svg": "750c",
	"./aligntop.svg": "0308",
	"./animation.svg": "3c21",
	"./audio.svg": "2333",
	"./backicon.svg": "b93a",
	"./bg-remover.svg": "78b7",
	"./boldicon.svg": "9817",
	"./burst.svg": "a883",
	"./cancel-svgrepo-com.svg": "e564",
	"./chevron.svg": "079d",
	"./chevrondown.svg": "b311",
	"./circle.svg": "b289",
	"./close-icon.svg": "3e79",
	"./constraints-proportion-icon.svg": "9d14",
	"./constraints-proportion-iconOFF.svg": "3e72",
	"./contract-screen.svg": "b57e",
	"./copied.svg": "1655",
	"./cropimage.svg": "68e1",
	"./details.svg": "d11f",
	"./equal-housing.svg": "8946",
	"./expand-screen.svg": "b30a",
	"./eye.svg": "7364",
	"./eyedropper.svg": "e32e",
	"./fade.svg": "5860",
	"./fdic.svg": "2d27",
	"./figma-plus.svg": "3010",
	"./fliphorizontal.svg": "1393",
	"./flipvertical.svg": "d984",
	"./hide-icon.svg": "246d",
	"./icons.svg": "6e85",
	"./image.svg": "931c",
	"./justify-text.svg": "76e6",
	"./list-bullets.svg": "2677",
	"./list-numbers.svg": "63b0",
	"./locklayer.svg": "8697",
	"./minus-collapse.svg": "ddd4",
	"./minus-decrement.svg": "bdb9",
	"./page-plus.svg": "6f89",
	"./pan.svg": "05b2",
	"./pause-w.svg": "a4d9",
	"./pause.svg": "644b",
	"./pauseRounded.svg": "f118",
	"./play.svg": "dab1",
	"./playButton.svg": "d339",
	"./playRounded.svg": "a311",
	"./plus-increment.svg": "71b5",
	"./plus.svg": "eb38",
	"./plus2.svg": "6d4a",
	"./polygon.svg": "baf3",
	"./qrcode.svg": "8b10",
	"./rectangle.svg": "3bba",
	"./redo.svg": "63dc",
	"./replayRounded.svg": "1456",
	"./reset-trim.svg": "c552",
	"./rest.svg": "6e6c",
	"./rotateleft.svg": "e6be",
	"./rotateright.svg": "3db6",
	"./search.svg": "d103",
	"./shape.svg": "22cc",
	"./shapes.svg": "6b03",
	"./spread.svg": "b581",
	"./star-favourite.svg": "9e81",
	"./star-un-favourite.svg": "d152",
	"./stomp.svg": "8558",
	"./stop.svg": "56b4",
	"./subscript.svg": "cede",
	"./superscript.svg": "2316",
	"./text-align-bottom.svg": "7714",
	"./text-align-vh-center.svg": "1899",
	"./text-horizontal-align-center.svg": "1fa1",
	"./text-horizontal-align-left.svg": "de2c",
	"./text-horizontal-align-right.svg": "176d",
	"./text.svg": "d36f",
	"./textaligncenter.svg": "01b0",
	"./textaligntop.svg": "4674",
	"./tick-svgrepo-com.svg": "7c57",
	"./transition-icon.svg": "2d8a",
	"./transition.svg": "2208",
	"./transparency.svg": "7c82",
	"./trash.svg": "af22",
	"./trash_red.svg": "5ffa",
	"./trim.svg": "ed0d",
	"./typewritter.svg": "3908",
	"./underlineicon.svg": "fd02",
	"./undo.svg": "34b1",
	"./unlock-icon.svg": "d161",
	"./video-icon.svg": "2da3",
	"./video.svg": "512b",
	"./vue.svg": "0dcb",
	"./zoom.svg": "6705",
	"./zoomdisable.svg": "d101",
	"./zoomin.svg": "617a",
	"./zoomout.svg": "bdd3"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "13b5";